import { get as _get } from 'lodash';
import * as actions from '../store/actions';
import api from '../store/api';
import { store } from '../store';

export const proceedWithGeocodedData = (geocodeData, property_address_value, history) => {
	store.dispatch(actions.formFlow.clearFormFlow());
	store.dispatch(actions.infoFeed.clearInfoFeedDisplay());
	// todo: edit this so we only same some program attributes and not all
	store.dispatch(actions.projectLeads.setFocusedProject(geocodeData.id)); // make it empty so we know we are creating a new one and this is not an edit.

	// we set the name of the project, as well as the searched address, to what they searched. That way we can store/recreate if needed.
	store.dispatch(
		actions.formFlow.updateFormFlowInputs({
			searched_address: property_address_value,
			project_name: property_address_value,
		})
	);
	store.dispatch(
		actions.formFlow.updateFormFlowComputed({
			...geocodeData,
			pace_funders_available: geocodeData?.funders_available,
			programs: _get(geocodeData, 'programs', []).map((d) => ({
				id: d.id,
				district_id: d.district_id,
			})),
		})
	);
	store.dispatch(
		actions.infoFeed.updateInfoFeedDisplay({
			property_address: {
				_property_address: geocodeData.address.formatted_address,
			},
		})
	);

	history.push('/project');
};

export const projectStartSearch = (property_address_value, history) => {

	return api
		.get('/geocode-address/', { address: property_address_value })
		.then((res) => {

			if (!res.data.address) {
				throw {"reject": "That address isn't valid"}
			}

			proceedWithGeocodedData(res.data, property_address_value, history);

		})

};

